import React from "react";
import { useQuery } from "@apollo/client";
import { GET_INVENTORY_PURCHASE_HISTORY } from "./graphql";

const PurchaseHistoryModal = ({ category, onClose }) => {
  const { data, loading, error } = useQuery(GET_INVENTORY_PURCHASE_HISTORY, {
    variables: { categoryId: category?.id },
    skip: !category,
    fetchPolicy: "network-only",
  });

  const historyList = data?.getInventoryPurchaseHistory || [];

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[80vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">
            Purchase History: {category?.name}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto">
          {loading ? (
            <div className="flex justify-center items-center py-10">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-600" />
            </div>
          ) : error ? (
            <div className="bg-red-50 text-red-800 p-4 rounded-lg text-sm">
              Failed to load purchase history: {error.message}
            </div>
          ) : historyList.length === 0 ? (
            <div className="text-center py-10 text-gray-500">
              No purchase history found for this category.
            </div>
          ) : (
            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="min-w-full text-left text-sm">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 font-semibold text-gray-700">Date</th>
                    <th className="px-4 py-3 font-semibold text-gray-700">Dealer Name</th>
                    <th className="px-4 py-3 font-semibold text-gray-700">MRP (₹)</th>
                    <th className="px-4 py-3 font-semibold text-gray-700">Rate (₹)</th>
                    <th className="px-4 py-3 font-semibold text-gray-700">Quantity</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {historyList.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-gray-600">
                        {item.date
                          ? new Date(item.date).toLocaleDateString("en-IN", { day: '2-digit', month: 'short', year: 'numeric' })
                          : "-"}
                      </td>
                      <td className="px-4 py-3 text-gray-800 font-medium">
                        {item.dealerName || "-"}
                      </td>
                      <td className="px-4 py-3 text-gray-600">{item.mrp || "-"}</td>
                      <td className="px-4 py-3 text-gray-600">{item.rate || "-"}</td>
                      <td className="px-4 py-3 text-gray-600">{item.quantity || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PurchaseHistoryModal;
